var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('point-table',{ref:"pointTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }